import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ProductOutlinedSvg from "@ant-design/icons-svg/es/asn/ProductOutlined";
import AntdIcon from "../components/AntdIcon";
var ProductOutlined = function ProductOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ProductOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ProductOutlined.displayName = 'ProductOutlined';
}
export default /*#__PURE__*/React.forwardRef(ProductOutlined);